import { tv } from "../tv.js";
import { allPaletteShades, allPaletteVariants } from "./basePaletteVariants.js";
const foregroundPaletteVariants = tv({
    base: '',
    variants: {
        palette: allPaletteVariants,
        shade: allPaletteShades
    },
    defaultVariants: {
        shade: '8'
    },
    compoundVariants: [
        {
            palette: 'primary',
            shade: '1',
            class: 'text-primary-1'
        },
        {
            palette: 'primary',
            shade: '2',
            class: 'text-primary-2'
        },
        {
            palette: 'primary',
            shade: '3',
            class: 'text-primary-3'
        },
        {
            palette: 'primary',
            shade: '4',
            class: 'text-primary-4'
        },
        {
            palette: 'primary',
            shade: '5',
            class: 'text-primary-5'
        },
        {
            palette: 'primary',
            shade: '6',
            class: 'text-primary-6'
        },
        {
            palette: 'primary',
            shade: '7',
            class: 'text-primary-7'
        },
        {
            palette: 'primary',
            shade: '8',
            class: 'text-primary-8'
        },
        {
            palette: 'primary',
            shade: '9',
            class: 'text-primary-9'
        },
        {
            palette: 'primary',
            shade: '10',
            class: 'text-primary-10'
        },
        {
            palette: 'primary',
            shade: '11',
            class: 'text-primary-11'
        },
        {
            palette: 'primary',
            shade: '12',
            class: 'text-primary-12'
        },
        {
            palette: 'primary',
            shade: '13',
            class: 'text-primary-13'
        },
        {
            palette: 'neutral',
            shade: '1',
            class: 'text-neutral-1'
        },
        {
            palette: 'neutral',
            shade: '2',
            class: 'text-neutral-2'
        },
        {
            palette: 'neutral',
            shade: '3',
            class: 'text-neutral-3'
        },
        {
            palette: 'neutral',
            shade: '4',
            class: 'text-neutral-4'
        },
        {
            palette: 'neutral',
            shade: '5',
            class: 'text-neutral-5'
        },
        {
            palette: 'neutral',
            shade: '6',
            class: 'text-neutral-6'
        },
        {
            palette: 'neutral',
            shade: '7',
            class: 'text-neutral-7'
        },
        {
            palette: 'neutral',
            shade: '8',
            class: 'text-neutral-8'
        },
        {
            palette: 'neutral',
            shade: '9',
            class: 'text-neutral-9'
        },
        {
            palette: 'neutral',
            shade: '10',
            class: 'text-neutral-10'
        },
        {
            palette: 'neutral',
            shade: '11',
            class: 'text-neutral-11'
        },
        {
            palette: 'neutral',
            shade: '12',
            class: 'text-neutral-12'
        },
        {
            palette: 'neutral',
            shade: '13',
            class: 'text-neutral-13'
        },
        {
            palette: 'actionPrimary',
            shade: '1',
            class: 'text-actionPrimary-1'
        },
        {
            palette: 'actionPrimary',
            shade: '2',
            class: 'text-actionPrimary-2'
        },
        {
            palette: 'actionPrimary',
            shade: '3',
            class: 'text-actionPrimary-3'
        },
        {
            palette: 'actionPrimary',
            shade: '4',
            class: 'text-actionPrimary-4'
        },
        {
            palette: 'actionPrimary',
            shade: '5',
            class: 'text-actionPrimary-5'
        },
        {
            palette: 'actionPrimary',
            shade: '6',
            class: 'text-actionPrimary-6'
        },
        {
            palette: 'actionPrimary',
            shade: '7',
            class: 'text-actionPrimary-7'
        },
        {
            palette: 'actionPrimary',
            shade: '8',
            class: 'text-actionPrimary-8'
        },
        {
            palette: 'actionPrimary',
            shade: '9',
            class: 'text-actionPrimary-9'
        },
        {
            palette: 'actionPrimary',
            shade: '10',
            class: 'text-actionPrimary-10'
        },
        {
            palette: 'actionPrimary',
            shade: '11',
            class: 'text-actionPrimary-11'
        },
        {
            palette: 'actionPrimary',
            shade: '12',
            class: 'text-actionPrimary-12'
        },
        {
            palette: 'actionPrimary',
            shade: '13',
            class: 'text-actionPrimary-13'
        },
        {
            palette: 'actionSecondary',
            shade: '1',
            class: 'text-actionSecondary-1'
        },
        {
            palette: 'actionSecondary',
            shade: '2',
            class: 'text-actionSecondary-2'
        },
        {
            palette: 'actionSecondary',
            shade: '3',
            class: 'text-actionSecondary-3'
        },
        {
            palette: 'actionSecondary',
            shade: '4',
            class: 'text-actionSecondary-4'
        },
        {
            palette: 'actionSecondary',
            shade: '5',
            class: 'text-actionSecondary-5'
        },
        {
            palette: 'actionSecondary',
            shade: '6',
            class: 'text-actionSecondary-6'
        },
        {
            palette: 'actionSecondary',
            shade: '7',
            class: 'text-actionSecondary-7'
        },
        {
            palette: 'actionSecondary',
            shade: '8',
            class: 'text-actionSecondary-8'
        },
        {
            palette: 'actionSecondary',
            shade: '9',
            class: 'text-actionSecondary-9'
        },
        {
            palette: 'actionSecondary',
            shade: '10',
            class: 'text-actionSecondary-10'
        },
        {
            palette: 'actionSecondary',
            shade: '11',
            class: 'text-actionSecondary-11'
        },
        {
            palette: 'actionSecondary',
            shade: '12',
            class: 'text-actionSecondary-12'
        },
        {
            palette: 'actionSecondary',
            shade: '13',
            class: 'text-actionSecondary-13'
        },
        {
            palette: 'actionShop',
            shade: '1',
            class: 'text-actionShop-1'
        },
        {
            palette: 'actionShop',
            shade: '2',
            class: 'text-actionShop-2'
        },
        {
            palette: 'actionShop',
            shade: '3',
            class: 'text-actionShop-3'
        },
        {
            palette: 'actionShop',
            shade: '4',
            class: 'text-actionShop-4'
        },
        {
            palette: 'actionShop',
            shade: '5',
            class: 'text-actionShop-5'
        },
        {
            palette: 'actionShop',
            shade: '6',
            class: 'text-actionShop-6'
        },
        {
            palette: 'actionShop',
            shade: '7',
            class: 'text-actionShop-7'
        },
        {
            palette: 'actionShop',
            shade: '8',
            class: 'text-actionShop-8'
        },
        {
            palette: 'actionShop',
            shade: '9',
            class: 'text-actionShop-9'
        },
        {
            palette: 'actionShop',
            shade: '10',
            class: 'text-actionShop-10'
        },
        {
            palette: 'actionShop',
            shade: '11',
            class: 'text-actionShop-11'
        },
        {
            palette: 'actionShop',
            shade: '12',
            class: 'text-actionShop-12'
        },
        {
            palette: 'actionShop',
            shade: '13',
            class: 'text-actionShop-13'
        },
        {
            palette: 'actionCritical',
            shade: '1',
            class: 'text-actionCritical-1'
        },
        {
            palette: 'actionCritical',
            shade: '2',
            class: 'text-actionCritical-2'
        },
        {
            palette: 'actionCritical',
            shade: '3',
            class: 'text-actionCritical-3'
        },
        {
            palette: 'actionCritical',
            shade: '4',
            class: 'text-actionCritical-4'
        },
        {
            palette: 'actionCritical',
            shade: '5',
            class: 'text-actionCritical-5'
        },
        {
            palette: 'actionCritical',
            shade: '6',
            class: 'text-actionCritical-6'
        },
        {
            palette: 'actionCritical',
            shade: '7',
            class: 'text-actionCritical-7'
        },
        {
            palette: 'actionCritical',
            shade: '8',
            class: 'text-actionCritical-8'
        },
        {
            palette: 'actionCritical',
            shade: '9',
            class: 'text-actionCritical-9'
        },
        {
            palette: 'actionCritical',
            shade: '10',
            class: 'text-actionCritical-10'
        },
        {
            palette: 'actionCritical',
            shade: '11',
            class: 'text-actionCritical-11'
        },
        {
            palette: 'actionCritical',
            shade: '12',
            class: 'text-actionCritical-12'
        },
        {
            palette: 'actionCritical',
            shade: '13',
            class: 'text-actionCritical-13'
        },
        {
            palette: 'favorite',
            shade: '1',
            class: 'text-favorite-1'
        },
        {
            palette: 'favorite',
            shade: '2',
            class: 'text-favorite-2'
        },
        {
            palette: 'favorite',
            shade: '3',
            class: 'text-favorite-3'
        },
        {
            palette: 'favorite',
            shade: '4',
            class: 'text-favorite-4'
        },
        {
            palette: 'favorite',
            shade: '5',
            class: 'text-favorite-5'
        },
        {
            palette: 'favorite',
            shade: '6',
            class: 'text-favorite-6'
        },
        {
            palette: 'favorite',
            shade: '7',
            class: 'text-favorite-7'
        },
        {
            palette: 'favorite',
            shade: '8',
            class: 'text-favorite-8'
        },
        {
            palette: 'favorite',
            shade: '9',
            class: 'text-favorite-9'
        },
        {
            palette: 'favorite',
            shade: '10',
            class: 'text-favorite-10'
        },
        {
            palette: 'favorite',
            shade: '11',
            class: 'text-favorite-11'
        },
        {
            palette: 'favorite',
            shade: '12',
            class: 'text-favorite-12'
        },
        {
            palette: 'favorite',
            shade: '13',
            class: 'text-favorite-13'
        },
        {
            palette: 'success',
            shade: '1',
            class: 'text-success-1'
        },
        {
            palette: 'success',
            shade: '2',
            class: 'text-success-2'
        },
        {
            palette: 'success',
            shade: '3',
            class: 'text-success-3'
        },
        {
            palette: 'success',
            shade: '4',
            class: 'text-success-4'
        },
        {
            palette: 'success',
            shade: '5',
            class: 'text-success-5'
        },
        {
            palette: 'success',
            shade: '6',
            class: 'text-success-6'
        },
        {
            palette: 'success',
            shade: '7',
            class: 'text-success-7'
        },
        {
            palette: 'success',
            shade: '8',
            class: 'text-success-8'
        },
        {
            palette: 'success',
            shade: '9',
            class: 'text-success-9'
        },
        {
            palette: 'success',
            shade: '10',
            class: 'text-success-10'
        },
        {
            palette: 'success',
            shade: '11',
            class: 'text-success-11'
        },
        {
            palette: 'success',
            shade: '12',
            class: 'text-success-12'
        },
        {
            palette: 'success',
            shade: '13',
            class: 'text-success-13'
        },
        {
            palette: 'error',
            shade: '1',
            class: 'text-error-1'
        },
        {
            palette: 'error',
            shade: '2',
            class: 'text-error-2'
        },
        {
            palette: 'error',
            shade: '3',
            class: 'text-error-3'
        },
        {
            palette: 'error',
            shade: '4',
            class: 'text-error-4'
        },
        {
            palette: 'error',
            shade: '5',
            class: 'text-error-5'
        },
        {
            palette: 'error',
            shade: '6',
            class: 'text-error-6'
        },
        {
            palette: 'error',
            shade: '7',
            class: 'text-error-7'
        },
        {
            palette: 'error',
            shade: '8',
            class: 'text-error-8'
        },
        {
            palette: 'error',
            shade: '9',
            class: 'text-error-9'
        },
        {
            palette: 'error',
            shade: '10',
            class: 'text-error-10'
        },
        {
            palette: 'error',
            shade: '11',
            class: 'text-error-11'
        },
        {
            palette: 'error',
            shade: '12',
            class: 'text-error-12'
        },
        {
            palette: 'error',
            shade: '13',
            class: 'text-error-13'
        },
        {
            palette: 'benefit',
            shade: '1',
            class: 'text-benefit-1'
        },
        {
            palette: 'benefit',
            shade: '2',
            class: 'text-benefit-2'
        },
        {
            palette: 'benefit',
            shade: '3',
            class: 'text-benefit-3'
        },
        {
            palette: 'benefit',
            shade: '4',
            class: 'text-benefit-4'
        },
        {
            palette: 'benefit',
            shade: '5',
            class: 'text-benefit-5'
        },
        {
            palette: 'benefit',
            shade: '6',
            class: 'text-benefit-6'
        },
        {
            palette: 'benefit',
            shade: '7',
            class: 'text-benefit-7'
        },
        {
            palette: 'benefit',
            shade: '8',
            class: 'text-benefit-8'
        },
        {
            palette: 'benefit',
            shade: '9',
            class: 'text-benefit-9'
        },
        {
            palette: 'benefit',
            shade: '10',
            class: 'text-benefit-10'
        },
        {
            palette: 'benefit',
            shade: '11',
            class: 'text-benefit-11'
        },
        {
            palette: 'benefit',
            shade: '12',
            class: 'text-benefit-12'
        },
        {
            palette: 'benefit',
            shade: '13',
            class: 'text-benefit-13'
        },
        {
            palette: 'urgency',
            shade: '1',
            class: 'text-urgency-1'
        },
        {
            palette: 'urgency',
            shade: '2',
            class: 'text-urgency-2'
        },
        {
            palette: 'urgency',
            shade: '3',
            class: 'text-urgency-3'
        },
        {
            palette: 'urgency',
            shade: '4',
            class: 'text-urgency-4'
        },
        {
            palette: 'urgency',
            shade: '5',
            class: 'text-urgency-5'
        },
        {
            palette: 'urgency',
            shade: '6',
            class: 'text-urgency-6'
        },
        {
            palette: 'urgency',
            shade: '7',
            class: 'text-urgency-7'
        },
        {
            palette: 'urgency',
            shade: '8',
            class: 'text-urgency-8'
        },
        {
            palette: 'urgency',
            shade: '9',
            class: 'text-urgency-9'
        },
        {
            palette: 'urgency',
            shade: '10',
            class: 'text-urgency-10'
        },
        {
            palette: 'urgency',
            shade: '11',
            class: 'text-urgency-11'
        },
        {
            palette: 'urgency',
            shade: '12',
            class: 'text-urgency-12'
        },
        {
            palette: 'urgency',
            shade: '13',
            class: 'text-urgency-13'
        },
        {
            palette: 'customer',
            shade: '1',
            class: 'text-customer-1'
        },
        {
            palette: 'customer',
            shade: '2',
            class: 'text-customer-2'
        },
        {
            palette: 'customer',
            shade: '3',
            class: 'text-customer-3'
        },
        {
            palette: 'customer',
            shade: '4',
            class: 'text-customer-4'
        },
        {
            palette: 'customer',
            shade: '5',
            class: 'text-customer-5'
        },
        {
            palette: 'customer',
            shade: '6',
            class: 'text-customer-6'
        },
        {
            palette: 'customer',
            shade: '7',
            class: 'text-customer-7'
        },
        {
            palette: 'customer',
            shade: '8',
            class: 'text-customer-8'
        },
        {
            palette: 'customer',
            shade: '9',
            class: 'text-customer-9'
        },
        {
            palette: 'customer',
            shade: '10',
            class: 'text-customer-10'
        },
        {
            palette: 'customer',
            shade: '11',
            class: 'text-customer-11'
        },
        {
            palette: 'customer',
            shade: '12',
            class: 'text-customer-12'
        },
        {
            palette: 'customer',
            shade: '13',
            class: 'text-customer-13'
        },
        {
            palette: 'caution',
            shade: '1',
            class: 'text-caution-1'
        },
        {
            palette: 'caution',
            shade: '2',
            class: 'text-caution-2'
        },
        {
            palette: 'caution',
            shade: '3',
            class: 'text-caution-3'
        },
        {
            palette: 'caution',
            shade: '4',
            class: 'text-caution-4'
        },
        {
            palette: 'caution',
            shade: '5',
            class: 'text-caution-5'
        },
        {
            palette: 'caution',
            shade: '6',
            class: 'text-caution-6'
        },
        {
            palette: 'caution',
            shade: '7',
            class: 'text-caution-7'
        },
        {
            palette: 'caution',
            shade: '8',
            class: 'text-caution-8'
        },
        {
            palette: 'caution',
            shade: '9',
            class: 'text-caution-9'
        },
        {
            palette: 'caution',
            shade: '10',
            class: 'text-caution-10'
        },
        {
            palette: 'caution',
            shade: '11',
            class: 'text-caution-11'
        },
        {
            palette: 'caution',
            shade: '12',
            class: 'text-caution-12'
        },
        {
            palette: 'caution',
            shade: '13',
            class: 'text-caution-13'
        },
        {
            palette: 'highlight',
            shade: '1',
            class: 'text-highlight-1'
        },
        {
            palette: 'highlight',
            shade: '2',
            class: 'text-highlight-2'
        },
        {
            palette: 'highlight',
            shade: '3',
            class: 'text-highlight-3'
        },
        {
            palette: 'highlight',
            shade: '4',
            class: 'text-highlight-4'
        },
        {
            palette: 'highlight',
            shade: '5',
            class: 'text-highlight-5'
        },
        {
            palette: 'highlight',
            shade: '6',
            class: 'text-highlight-6'
        },
        {
            palette: 'highlight',
            shade: '7',
            class: 'text-highlight-7'
        },
        {
            palette: 'highlight',
            shade: '8',
            class: 'text-highlight-8'
        },
        {
            palette: 'highlight',
            shade: '9',
            class: 'text-highlight-9'
        },
        {
            palette: 'highlight',
            shade: '10',
            class: 'text-highlight-10'
        },
        {
            palette: 'highlight',
            shade: '11',
            class: 'text-highlight-11'
        },
        {
            palette: 'highlight',
            shade: '12',
            class: 'text-highlight-12'
        },
        {
            palette: 'highlight',
            shade: '13',
            class: 'text-highlight-13'
        },
        {
            palette: 'priceSale',
            shade: '1',
            class: 'text-priceSale-1'
        },
        {
            palette: 'priceSale',
            shade: '2',
            class: 'text-priceSale-2'
        },
        {
            palette: 'priceSale',
            shade: '3',
            class: 'text-priceSale-3'
        },
        {
            palette: 'priceSale',
            shade: '4',
            class: 'text-priceSale-4'
        },
        {
            palette: 'priceSale',
            shade: '5',
            class: 'text-priceSale-5'
        },
        {
            palette: 'priceSale',
            shade: '6',
            class: 'text-priceSale-6'
        },
        {
            palette: 'priceSale',
            shade: '7',
            class: 'text-priceSale-7'
        },
        {
            palette: 'priceSale',
            shade: '8',
            class: 'text-priceSale-8'
        },
        {
            palette: 'priceSale',
            shade: '9',
            class: 'text-priceSale-9'
        },
        {
            palette: 'priceSale',
            shade: '10',
            class: 'text-priceSale-10'
        },
        {
            palette: 'priceSale',
            shade: '11',
            class: 'text-priceSale-11'
        },
        {
            palette: 'priceSale',
            shade: '12',
            class: 'text-priceSale-12'
        },
        {
            palette: 'priceSale',
            shade: '13',
            class: 'text-priceSale-13'
        },
        {
            palette: 'priceRetail',
            shade: '1',
            class: 'text-priceRetail-1'
        },
        {
            palette: 'priceRetail',
            shade: '2',
            class: 'text-priceRetail-2'
        },
        {
            palette: 'priceRetail',
            shade: '3',
            class: 'text-priceRetail-3'
        },
        {
            palette: 'priceRetail',
            shade: '4',
            class: 'text-priceRetail-4'
        },
        {
            palette: 'priceRetail',
            shade: '5',
            class: 'text-priceRetail-5'
        },
        {
            palette: 'priceRetail',
            shade: '6',
            class: 'text-priceRetail-6'
        },
        {
            palette: 'priceRetail',
            shade: '7',
            class: 'text-priceRetail-7'
        },
        {
            palette: 'priceRetail',
            shade: '8',
            class: 'text-priceRetail-8'
        },
        {
            palette: 'priceRetail',
            shade: '9',
            class: 'text-priceRetail-9'
        },
        {
            palette: 'priceRetail',
            shade: '10',
            class: 'text-priceRetail-10'
        },
        {
            palette: 'priceRetail',
            shade: '11',
            class: 'text-priceRetail-11'
        },
        {
            palette: 'priceRetail',
            shade: '12',
            class: 'text-priceRetail-12'
        },
        {
            palette: 'priceRetail',
            shade: '13',
            class: 'text-priceRetail-13'
        },
        {
            palette: 'marketingBrand',
            shade: '1',
            class: 'text-marketingBrand-1'
        },
        {
            palette: 'marketingBrand',
            shade: '2',
            class: 'text-marketingBrand-2'
        },
        {
            palette: 'marketingBrand',
            shade: '3',
            class: 'text-marketingBrand-3'
        },
        {
            palette: 'marketingBrand',
            shade: '4',
            class: 'text-marketingBrand-4'
        },
        {
            palette: 'marketingBrand',
            shade: '5',
            class: 'text-marketingBrand-5'
        },
        {
            palette: 'marketingBrand',
            shade: '6',
            class: 'text-marketingBrand-6'
        },
        {
            palette: 'marketingBrand',
            shade: '7',
            class: 'text-marketingBrand-7'
        },
        {
            palette: 'marketingBrand',
            shade: '8',
            class: 'text-marketingBrand-8'
        },
        {
            palette: 'marketingBrand',
            shade: '9',
            class: 'text-marketingBrand-9'
        },
        {
            palette: 'marketingBrand',
            shade: '10',
            class: 'text-marketingBrand-10'
        },
        {
            palette: 'marketingBrand',
            shade: '11',
            class: 'text-marketingBrand-11'
        },
        {
            palette: 'marketingBrand',
            shade: '12',
            class: 'text-marketingBrand-12'
        },
        {
            palette: 'marketingBrand',
            shade: '13',
            class: 'text-marketingBrand-13'
        },
        {
            palette: 'promoPrimary',
            shade: '1',
            class: 'text-promoPrimary-1'
        },
        {
            palette: 'promoPrimary',
            shade: '2',
            class: 'text-promoPrimary-2'
        },
        {
            palette: 'promoPrimary',
            shade: '3',
            class: 'text-promoPrimary-3'
        },
        {
            palette: 'promoPrimary',
            shade: '4',
            class: 'text-promoPrimary-4'
        },
        {
            palette: 'promoPrimary',
            shade: '5',
            class: 'text-promoPrimary-5'
        },
        {
            palette: 'promoPrimary',
            shade: '6',
            class: 'text-promoPrimary-6'
        },
        {
            palette: 'promoPrimary',
            shade: '7',
            class: 'text-promoPrimary-7'
        },
        {
            palette: 'promoPrimary',
            shade: '8',
            class: 'text-promoPrimary-8'
        },
        {
            palette: 'promoPrimary',
            shade: '9',
            class: 'text-promoPrimary-9'
        },
        {
            palette: 'promoPrimary',
            shade: '10',
            class: 'text-promoPrimary-10'
        },
        {
            palette: 'promoPrimary',
            shade: '11',
            class: 'text-promoPrimary-11'
        },
        {
            palette: 'promoPrimary',
            shade: '12',
            class: 'text-promoPrimary-12'
        },
        {
            palette: 'promoPrimary',
            shade: '13',
            class: 'text-promoPrimary-13'
        },
        {
            palette: 'penny',
            shade: '1',
            class: 'text-penny-1'
        },
        {
            palette: 'penny',
            shade: '2',
            class: 'text-penny-2'
        },
        {
            palette: 'penny',
            shade: '3',
            class: 'text-penny-3'
        },
        {
            palette: 'penny',
            shade: '4',
            class: 'text-penny-4'
        },
        {
            palette: 'penny',
            shade: '5',
            class: 'text-penny-5'
        },
        {
            palette: 'penny',
            shade: '6',
            class: 'text-penny-6'
        },
        {
            palette: 'penny',
            shade: '7',
            class: 'text-penny-7'
        },
        {
            palette: 'penny',
            shade: '8',
            class: 'text-penny-8'
        },
        {
            palette: 'penny',
            shade: '9',
            class: 'text-penny-9'
        },
        {
            palette: 'penny',
            shade: '10',
            class: 'text-penny-10'
        },
        {
            palette: 'penny',
            shade: '11',
            class: 'text-penny-11'
        },
        {
            palette: 'penny',
            shade: '12',
            class: 'text-penny-12'
        },
        {
            palette: 'penny',
            shade: '13',
            class: 'text-penny-13'
        },
        {
            palette: 'pennyAccents',
            shade: '1',
            class: 'text-pennyAccents-1'
        },
        {
            palette: 'pennyAccents',
            shade: '2',
            class: 'text-pennyAccents-2'
        },
        {
            palette: 'pennyAccents',
            shade: '3',
            class: 'text-pennyAccents-3'
        },
        {
            palette: 'pennyAccents',
            shade: '4',
            class: 'text-pennyAccents-4'
        },
        {
            palette: 'pennyAccents',
            shade: '5',
            class: 'text-pennyAccents-5'
        },
        {
            palette: 'pennyAccents',
            shade: '6',
            class: 'text-pennyAccents-6'
        },
        {
            palette: 'pennyAccents',
            shade: '7',
            class: 'text-pennyAccents-7'
        },
        {
            palette: 'pennyAccents',
            shade: '8',
            class: 'text-pennyAccents-8'
        },
        {
            palette: 'pennyAccents',
            shade: '9',
            class: 'text-pennyAccents-9'
        },
        {
            palette: 'pennyAccents',
            shade: '10',
            class: 'text-pennyAccents-10'
        },
        {
            palette: 'pennyAccents',
            shade: '11',
            class: 'text-pennyAccents-11'
        },
        {
            palette: 'pennyAccents',
            shade: '12',
            class: 'text-pennyAccents-12'
        },
        {
            palette: 'pennyAccents',
            shade: '13',
            class: 'text-pennyAccents-13'
        },
        {
            palette: 'vipMember',
            shade: '1',
            class: 'text-vipMember-1'
        },
        {
            palette: 'vipMember',
            shade: '2',
            class: 'text-vipMember-2'
        },
        {
            palette: 'vipMember',
            shade: '3',
            class: 'text-vipMember-3'
        },
        {
            palette: 'vipMember',
            shade: '4',
            class: 'text-vipMember-4'
        },
        {
            palette: 'vipMember',
            shade: '5',
            class: 'text-vipMember-5'
        },
        {
            palette: 'vipMember',
            shade: '6',
            class: 'text-vipMember-6'
        },
        {
            palette: 'vipMember',
            shade: '7',
            class: 'text-vipMember-7'
        },
        {
            palette: 'vipMember',
            shade: '8',
            class: 'text-vipMember-8'
        },
        {
            palette: 'vipMember',
            shade: '9',
            class: 'text-vipMember-9'
        },
        {
            palette: 'vipMember',
            shade: '10',
            class: 'text-vipMember-10'
        },
        {
            palette: 'vipMember',
            shade: '11',
            class: 'text-vipMember-11'
        },
        {
            palette: 'vipMember',
            shade: '12',
            class: 'text-vipMember-12'
        },
        {
            palette: 'vipMember',
            shade: '13',
            class: 'text-vipMember-13'
        },
        {
            palette: 'vipBlue',
            shade: '1',
            class: 'text-vipBlue-1'
        },
        {
            palette: 'vipBlue',
            shade: '2',
            class: 'text-vipBlue-2'
        },
        {
            palette: 'vipBlue',
            shade: '3',
            class: 'text-vipBlue-3'
        },
        {
            palette: 'vipBlue',
            shade: '4',
            class: 'text-vipBlue-4'
        },
        {
            palette: 'vipBlue',
            shade: '5',
            class: 'text-vipBlue-5'
        },
        {
            palette: 'vipBlue',
            shade: '6',
            class: 'text-vipBlue-6'
        },
        {
            palette: 'vipBlue',
            shade: '7',
            class: 'text-vipBlue-7'
        },
        {
            palette: 'vipBlue',
            shade: '8',
            class: 'text-vipBlue-8'
        },
        {
            palette: 'vipBlue',
            shade: '9',
            class: 'text-vipBlue-9'
        },
        {
            palette: 'vipBlue',
            shade: '10',
            class: 'text-vipBlue-10'
        },
        {
            palette: 'vipBlue',
            shade: '11',
            class: 'text-vipBlue-11'
        },
        {
            palette: 'vipBlue',
            shade: '12',
            class: 'text-vipBlue-12'
        },
        {
            palette: 'vipBlue',
            shade: '13',
            class: 'text-vipBlue-13'
        },
        {
            palette: 'vipGold',
            shade: '1',
            class: 'text-vipGold-1'
        },
        {
            palette: 'vipGold',
            shade: '2',
            class: 'text-vipGold-2'
        },
        {
            palette: 'vipGold',
            shade: '3',
            class: 'text-vipGold-3'
        },
        {
            palette: 'vipGold',
            shade: '4',
            class: 'text-vipGold-4'
        },
        {
            palette: 'vipGold',
            shade: '5',
            class: 'text-vipGold-5'
        },
        {
            palette: 'vipGold',
            shade: '6',
            class: 'text-vipGold-6'
        },
        {
            palette: 'vipGold',
            shade: '7',
            class: 'text-vipGold-7'
        },
        {
            palette: 'vipGold',
            shade: '8',
            class: 'text-vipGold-8'
        },
        {
            palette: 'vipGold',
            shade: '9',
            class: 'text-vipGold-9'
        },
        {
            palette: 'vipGold',
            shade: '10',
            class: 'text-vipGold-10'
        },
        {
            palette: 'vipGold',
            shade: '11',
            class: 'text-vipGold-11'
        },
        {
            palette: 'vipGold',
            shade: '12',
            class: 'text-vipGold-12'
        },
        {
            palette: 'vipGold',
            shade: '13',
            class: 'text-vipGold-13'
        },
        {
            palette: 'vipPlatinum',
            shade: '1',
            class: 'text-vipPlatinum-1'
        },
        {
            palette: 'vipPlatinum',
            shade: '2',
            class: 'text-vipPlatinum-2'
        },
        {
            palette: 'vipPlatinum',
            shade: '3',
            class: 'text-vipPlatinum-3'
        },
        {
            palette: 'vipPlatinum',
            shade: '4',
            class: 'text-vipPlatinum-4'
        },
        {
            palette: 'vipPlatinum',
            shade: '5',
            class: 'text-vipPlatinum-5'
        },
        {
            palette: 'vipPlatinum',
            shade: '6',
            class: 'text-vipPlatinum-6'
        },
        {
            palette: 'vipPlatinum',
            shade: '7',
            class: 'text-vipPlatinum-7'
        },
        {
            palette: 'vipPlatinum',
            shade: '8',
            class: 'text-vipPlatinum-8'
        },
        {
            palette: 'vipPlatinum',
            shade: '9',
            class: 'text-vipPlatinum-9'
        },
        {
            palette: 'vipPlatinum',
            shade: '10',
            class: 'text-vipPlatinum-10'
        },
        {
            palette: 'vipPlatinum',
            shade: '11',
            class: 'text-vipPlatinum-11'
        },
        {
            palette: 'vipPlatinum',
            shade: '12',
            class: 'text-vipPlatinum-12'
        },
        {
            palette: 'vipPlatinum',
            shade: '13',
            class: 'text-vipPlatinum-13'
        }
    ]
});
export { foregroundPaletteVariants };
